import React from 'react';

import { Button, Spacer, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { FaPlus } from 'react-icons/fa';

export const AppointmentButtonPlaceHolder = ({
  label,
  selectedDateCount,
  maxDatesCount,
  ...props
}) => {
  return (
    <Button
      my="6"
      w="full"
      h="auto"
      d="flex"
      justifyContent="start"
      p="4"
      backgroundColor="gray.50"
      border="1px dashed"
      borderColor="gray.200"
      borderRadius="md"
      transition="0.2s"
      {...props}
    >
      <Button
        as="span"
        leftIcon={<FaPlus />}
        size="sm"
        variant="outline"
        backgroundColor="gray.100"
        border="none"
      >
        {label}
      </Button>
      <Spacer />
      <Text>
        {selectedDateCount} / {maxDatesCount}
      </Text>
    </Button>
  );
};

AppointmentButtonPlaceHolder.propTypes = {
  label: PropTypes.string,
  selectedDateCount: PropTypes.number,
  maxDatesCount: PropTypes.number,
};

AppointmentButtonPlaceHolder.defaultProps = {
  label: 'Ajouter une date',
  selectedDateCount: 0,
  maxDatesCount: 3,
};
